import { useRef } from 'react';
import { interactionWrapper } from '../utils';
/**
 * This is like `useFn` but returns void and runs after interactions or
 * animations have completed. Uses InteractionManager.runAfterInteractions in
 * React Native, and requestAnimationFrame on web. Falls back to microtask
 * otherwise.
 *
 * NOTE: When using react-native-gesture-handler, interaction handles don't
 *  seem be created. Presumably, since it's processing on the UI thread,
 *  there's no real reason to create interaction handles. This appears to be
 *  true for react-native-reanimated as well. It does appear that interaction
 *  handles are create sometimes, but I can't figure out exactly why. I believe
 *  that the elements that are causing interaction handles are somehow not
 *  being handled by gesture handler (or aren't part of gesture handler root,
 *  for whatever reason). Either way, this will be effective for anything
 *  that is using the InteractionManager, including if we want to use it
 *  ourselves.
 *
 * NOTE: It's possible to see when interaction effects are created / cleared
 *  by setting the `DEBUG` flag to `true` in:
 *  'react-native/Libraries/Interaction/InteractionManager'
 *
 * @see useFn
 */
export const useInteractionFn = (fn) => {
    const fnRef = useRef(fn);
    fnRef.current = fn;
    return useRef((...args) => interactionWrapper(() => fnRef.current(...args)))
        .current;
};
//# sourceMappingURL=useInteractionFn.js.map